/**
 * External dependencies
 */
import { AxiosInstance } from 'axios';
import { createAxios } from '@naruto/naruto-api/src/tools';
import Header from '@naruto/naruto-api/src/tools/Header';

/**
 * Internal dependencies
 */
import UserAPI from '@naruto/bgdcms/src/api/user-apis';
import AccountAPI from '@naruto/bgdcms/src/api/account-apis';
import ProjectAPI from '@naruto/bgdcms/src/api/project-apis';
import ServiceAPI from '@naruto/bgdcms/src/api/service-apis';
import ContactAPI from '@naruto/bgdcms/src/api/contact-apis';
import SiteMetaAPI from '@naruto/bgdcms/src/api/site-meta-apis';
import AttachmentAPI from '@naruto/bgdcms/src/api/attachment-apis';
import { BaseAPIParams } from './types';

class API {
  private axios: AxiosInstance;

  public baseHeader: Header;

  public user: UserAPI;

  public account: AccountAPI;

  public project: ProjectAPI;

  public service: ServiceAPI;

  public contact: ContactAPI;

  public siteMeta: SiteMetaAPI;

  public attachment: AttachmentAPI;

  constructor({ host }: BaseAPIParams) {
    this.axios = createAxios({ host });
    this.baseHeader = new Header();
    this.user = new UserAPI({ axios: this.axios, header: this.baseHeader });
    this.account = new AccountAPI({ axios: this.axios, header: this.baseHeader });
    this.project = new ProjectAPI({ axios: this.axios, header: this.baseHeader });
    this.service = new ServiceAPI({ axios: this.axios, header: this.baseHeader });
    this.contact = new ContactAPI({ axios: this.axios, header: this.baseHeader });
    this.siteMeta = new SiteMetaAPI({ axios: this.axios, header: this.baseHeader });
    this.attachment = new AttachmentAPI({ axios: this.axios, header: this.baseHeader });
  }
}

export default API;
